module.exports = __webpack_public_path__ + "img/371.187522a4.png";